// Copyright ©️ 2026 eVolve MEP, LLC

import React, { useState } from 'react';

import type { WorkOrder, WorkOrderItem } from '@evolvemep/api-ts';
import { Button } from '@mantine/core';

import { EvolveIcon } from 'assets/icons/EvolveIcon';
import { AddWriteInItemToWorkOrderPopover } from 'modules/Shop/WorkOrders/WorkOrderDetail/Items/AddWriteInItemToWorkOrderPopover';

type Props = {
  workOrder: WorkOrder;
  parentWorkOrderItem?: WorkOrderItem;
  onItemAdded?: (item: WorkOrderItem) => void;
};

export const AddWorkOrderWriteInItemButton = ({ workOrder, parentWorkOrderItem, onItemAdded }: Props) => {
  const [opened, setOpened] = useState(false);

  return (
    <AddWriteInItemToWorkOrderPopover
      opened={opened}
      onClose={() => setOpened(false)}
      workOrder={workOrder}
      parentWorkOrderItem={parentWorkOrderItem}
      onItemAdded={onItemAdded}
    >
      <Button variant="light" onClick={() => setOpened(true)} leftSection={<EvolveIcon icon="WriteInItem" />}>
        Add write-in item
      </Button>
    </AddWriteInItemToWorkOrderPopover>
  );
};
